/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Alternatives_EyebrowInputs */

const en_directory_taxonomy_alternatives_eyebrow = /** @type {(inputs: Directory_Taxonomy_Alternatives_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product alternatives`)
};

const zh_directory_taxonomy_alternatives_eyebrow = /** @type {(inputs: Directory_Taxonomy_Alternatives_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品替代方案`)
};

/**
* | output |
* | --- |
* | "Product alternatives" |
*
* @param {Directory_Taxonomy_Alternatives_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_alternatives_eyebrow = /** @type {((inputs?: Directory_Taxonomy_Alternatives_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Alternatives_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_alternatives_eyebrow(inputs)
	return zh_directory_taxonomy_alternatives_eyebrow(inputs)
});
export { directory_taxonomy_alternatives_eyebrow as "directory.taxonomy.alternatives.eyebrow" }